<h3 class="p-b p-b-9-s h2">
    @if (!!content?.title) {
    <span *iCms="'title' of content"></span>
    } @else {
    {{'How would you like to receive your order?' | translate}}
    }
</h3>
